import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Monogram from '../../assets/monogram.svg';

/**
 * Shared shell for the public legal documents (/terms, /privacy).
 *
 * These are the only two pages besides /login that render outside the authenticated
 * Layout, so they carry their own chrome. Shell and typography live here rather than
 * in each document so the two cannot drift apart visually - and so Google's OAuth
 * consent screen, which links to both, gets a consistent pair of pages.
 */
// Where employees are told to direct questions about either document. Lives here,
// not in each page, so the two documents cannot end up naming different addresses.
export const HR_CONTACT = 'hr@bytecorp.io';

const LegalPage = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-3xl mx-auto">
      <div className="text-center">
        <img src={Monogram} alt="ByteCorp Monogram" className="mx-auto h-14 w-14 object-contain drop-shadow" />
        <h1 className="mt-6 text-3xl font-bold text-gray-900">{title}</h1>
        <p className="mt-2 text-sm text-gray-600">Last updated {lastUpdated}</p>
      </div>

      <div className="mt-8 bg-white py-8 px-6 sm:px-10 shadow-soft rounded-xl">
        {children}
      </div>

      <div className="mt-8 flex justify-center">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to sign in
        </Link>
      </div>
    </div>
  </div>
);

export const Section = ({ heading, children }) => (
  <section className="mt-8 first:mt-0">
    <h2 className="text-lg font-semibold text-gray-900">{heading}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-gray-700">{children}</div>
  </section>
);

export const List = ({ children }) => (
  <ul className="ml-5 list-disc space-y-2">{children}</ul>
);

export const Term = ({ label, children }) => (
  <li>
    <span className="font-medium text-gray-900">{label}</span> {children}
  </li>
);

export default LegalPage;
